import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './EventsBox.module.scss';

export default class EventsBox extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    dateDay: PropTypes.string.isRequired,
    dateMonth: PropTypes.string.isRequired,
    dateYear: PropTypes.string.isRequired
  };

  render() {
    const { title, description, dateDay, dateMonth, dateYear } = this.props;
    return (
      <div className={styles.Wrapper}>
        <div className={styles.DateBox}>
          <span className={styles.DateParagraph}>{dateDay}.</span>
          <span className={styles.DateParagraph}>{dateMonth}</span>
          <p className={styles.DateParagraph}>{dateYear}</p>
        </div>
        <div className={styles.InfoBox}>
          <h4 className={styles.InfoTitle}>{title}</h4>
          <p
            className={styles.InfoParagraph}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/NewsAndEvents/Components/EventsBox/EventsBox.js